import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';
import remoteConsole from '@sparta.homepage.utilities/remote-logging-utility/dist/es6.js';
import spartaGlobalFunctionsUtility from '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import { CONSTANTS } from '@sparta.homepage-business.helpers/business-homepage-helper/dist/es6.js';

/* global alloy bactm */
let isBusinessAdHoc = false;
const {
  BUSINESS_AUDIENCES_LIST,
  QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE,
  QUERY_PARAM_TO_ALLOY_CONVERSION_BUSINESS_AUDIENCE,
  BUSINESS_AUDIENCES,
  ALLOY_CONVERSION_BUSINESS_AUDIENCE
} = CONSTANTS;
const {
  DEFAULT_LOB
} = BUSINESS_AUDIENCES;

/**
 * @class AlloyBootstrapUtility
 */
class AlloyBootstrapUtility {
  /**
   * constructor
   */
  constructor() {
    this.signOnBannerAdContainer = spaParams.pageParams.signOnBannerAdContainer;
    this.mainAdContainers = spaParams.pageParams.mainAdContainers;
    this.navTabAdContainers = spaParams.pageParams.navTabContainers;
    this.pageVersion = spaParams.pageParams.pageVersion || null;

    // Business Specific Page Params
    /** @type {string} Based on the page config get the customer type that uses this page */
    this.customerType = spaParams.pageParams.customerType;
    /** @type {string[]} List of Regional mBoxes that possess the audience size container */
    this.businessContainer = spaParams.pageParams?.businessContainer || [];
    /** @type {string[]} List of Regional mBoxes that appear above the fold */
    this.aboveTheFoldContainers = spaParams.pageParams?.aboveTheFoldContainers || [];
    /** @type {string[]} List of Regional mBoxes that appear below the fold */
    this.belowTheFoldContainers = spaParams.pageParams?.belowTheFoldContainers || [];
    /** @type {object} Object of all of the current Alloy responses in schema of { [container]: {[offerFriendlyName]: {alloyResponse}} } */
    this.alloyConfig = {};
    /** @type {string | null} This is the value of the business decided from Alloy */
    this.alloyBusinessSize = null;
    this.businessSizePublished = false;
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
    this.optedOut = parseInt(spartaGlobalFunctionsUtility.spartaGetCookie('throttle_value'), 10) === 999;
    this.timeoutOverride = spartaGlobalFunctionsUtility.getUrlParam('timeoutOverride');
    this.alloyDisabled = spartaGlobalFunctionsUtility.getUrlParam('alloyDisable');
    this.timeout = this.timeoutOverride ? this.timeoutOverride : parseInt(spaParams.siteParams.targetingTimeout, 10);
    this.targetingDisabled = !!spaParams.siteParams.disableTargeting;
    this.cdn = spaParams.siteParams.cdn.host;
    this.defaultContentRendered = false;
    this.alloyContentRendered = false;
    this.localBusinessSize;
    this.completedContainers = {};
    this.completedScopes = {};
    if (this.cdn) {
      this.cdnDark = this.cdn.includes('1') ? this.cdn.replace('1', '2') : this.cdn.replace('2', '1');
      this.cdnDarkPattern = new RegExp(this.cdnDark, 'gi');
    } else {
      this.cdnDarkPattern = '';
    }
    this.langPattern = new RegExp(window.sparta.language, 'i');
    const {
      customerType
    } = spaParams.pageParams;
    this.customerPattern = new RegExp(customerType, 'i');
    this.payload = {
      'profile.BA_0021': spartaGlobalFunctionsUtility.spartaGetCookie('BA_0021') || null,
      'profile.BOA_0020': spartaGlobalFunctionsUtility.spartaGetCookie('BOA_0020') || null,
      'profile.BOA_HPR': spartaGlobalFunctionsUtility.spartaGetCookie('BOA_HPR') || null,
      'profile.state': spartaGlobalFunctionsUtility.spartaGetCookie('state') || null,
      'profile.tc_lang': `${window.sparta.language}_US` || null
    };
  }

  /**
   * Make initial calls to targeting API and listen for events requesting targeted content. Content
   * for ad containers passed via module params will be requested on page load.
   *
   * @returns {void}
   */
  init() {
    this.getMarketingAssets();
  }

  /**
   * Get the Business Audience from Alloy by passing the payload which will include the saved 
   * audience from session storage.
   * 
   * @param {string[]} adContainer specific mBox containers that we want to target on this call
   * @returns {Promise}
   */
  getBusinessSize(containersArray) {
    return new Promise((resolve, reject) => {
      // if default content has been rendered, return
      if (this.defaultContentRendered) {
        // eslint-disable-next-line no-console
        console.warn('Alloy is ready but default content has already rendered');
        return;
      }
      alloy('sendEvent', {
        xdm: {
          eventType: 'regionalmbox.request'
        },
        data: {
          __adobe: {
            target: this.payload
          }
        },
        decisionScopes: [...containersArray]
      }).then(result => {
        if (result.decisions && result.decisions.length > 0) {
          const {
            decisions
          } = result;
          // render ad containers based on results
          decisions.forEach(decision => {
            const {
              scope
            } = decision;
            // ensure scope is among containers being requested
            if (containersArray.indexOf(scope) !== -1) {
              if (spaParams.siteParams.jsTimer && performance.mark !== undefined) {
                performance.mark(`${scope}-loadContent-start`);
              }
              const filteredDecision = decision.items.filter(item => item.schema === 'https://ns.adobe.com/personalization/html-content-item');
              const {
                content
              } = filteredDecision[0].data;
              const contentObj = JSON.parse(content);
              let {
                audience
              } = contentObj;
              if (!audience) {
                audience = null;
              }
              // Add audience to payload
              // TODO: NOTE: Do we need this.
              // this.payload.audience = audience;
              resolve(audience);
            } else {
              // TODO: review, I think I just need to have this skip this one. as Alloy sent something I am not targetting for.
              throw new Error('Scope not found in containersArray');
            }
          });
        } else {
          throw new Error("No decisions in reponse");
        }
      }).catch(e => {
        console.log('ERROR', e); // TODO: Use proper logger.
        reject(null);
      });
    });
  }

  /**
   * Get data from cookie set by tag-manager if available.
   *
   * @returns {Object} the tag manager cookie or null
   */
  getTagManagerData() {
    try {
      return JSON.parse(spartaGlobalFunctionsUtility.spartaGetCookie('bactm_lts'));
    } catch (e) {
      return {};
    }
  }

  /**
   * @method optedOutRoute
   * @param {Array} adContainers array of ad containers
   * @returns {void}
   */
  optedOutRoute(adContainers) {
    adContainers.forEach(container => {
      this.dispatchTargetedContent(container);
      this.defaultContentRendered = true;
      let load;
      if (this.optedOut) load = 'opt-out';
      if (this.targetingDisabled) load = 'disabled';
      this.bactmLog({
        type: 'at-get',
        adContainer: container,
        load
      });
    });
  }

  /**
   * Convert the alloy response to a standardized response for the JCRs
   * 
   * @param {string} size The audience from alloy about the business size
   * @returns {string} The user friendly string representation of the business size.
   */
  convertAlloyBusinessSize(size) {
    let updatedSize = size;
    switch (size) {
      case 'default':
        updatedSize = ALLOY_CONVERSION_BUSINESS_AUDIENCE.default;
        break;
      case 'sbClients':
        updatedSize = ALLOY_CONVERSION_BUSINESS_AUDIENCE.sbClients;
        break;
      case 'sbProspect':
        updatedSize = ALLOY_CONVERSION_BUSINESS_AUDIENCE.sbProspects;
        break;
      case 'midSize':
        updatedSize = ALLOY_CONVERSION_BUSINESS_AUDIENCE.midSize;
        break;
    }
    return updatedSize;
  }
  updateUrlQueryParams(audience = null) {
    if (!audience) return;
    const audiences = {
      STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB: "SBPHP",
      STARTUP_MICRO_BUSINESS_CLIENT_LOB: "SBCHP",
      ESTABLISHED_BUSINESS_LOB: "MSBHP",
      LARGE_CORP_LOB: "",
      MIDDLE_MARKET_LOB: ""
    };
    function addOrUpdateQueryParam(key, value, remove = false) {
      const url = new URL(window.location.href);
      if (remove) {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
      return url.toString();
    }
    addOrUpdateQueryParam('src_cd', audiences[audience]);
  }
  getBusinessDesignation(alloyBusinessSize) {
    const _that = this;
    const localStorageBusiness = spartaStoreUtility.getPersisted('businessType', 'localStorage');
    const sessionStorageBusiness = spartaStoreUtility.getPersisted('businessType', 'sessionStorage');
    const businessTypeOneTime = spartaStoreUtility.getPersisted('businessTypeOneTime', 'sessionStorage');
    const wasBusinessTypeOneTimeCookie = spartaStoreUtility.getPersisted('wasBusinessTypeOneTime', 'sessionStorage');
    if (wasBusinessTypeOneTimeCookie) {
      this.wasBusinessTypeOneTime = wasBusinessTypeOneTimeCookie;
    }
    const evaluatedAlloyBusinessSize = this.convertAlloyBusinessSize(alloyBusinessSize);
    const value = sessionStorageBusiness;
    let result = DEFAULT_LOB;
    let isOneTime = false;

    // Checks to confirm if audience is found in list of active audiences
    const checkIfExists = audience => {
      return BUSINESS_AUDIENCES_LIST.indexOf(audience) > -1;
    };
    try {
      switch (true) {
        // Loads one time override (i.e. choosing view as)
        case checkIfExists(QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE[businessTypeOneTime]):
          isOneTime = true;
          result = QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE[businessTypeOneTime];
          break;
        // Use the business size that Alloy claims they are
        case checkIfExists(evaluatedAlloyBusinessSize):
          // If Alloy provided DEFAULT_LOB we will allow another value to update
          if (evaluatedAlloyBusinessSize !== 'DEFAULT_LOB') {
            result = evaluatedAlloyBusinessSize;
            break;
          }
        // Loads from URL query param (e.g. src_cd=SBPHP, src_cd=SBCHP, or src_cd=MSBHP)
        case this.viewingAsBusiness:
          if (checkIfExists(QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE[this.viewingAsBusiness])) {
            result = QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE[this.viewingAsBusiness];
          } else {
            if (checkIfExists(sessionStorageBusiness)) {
              result = sessionStorageBusiness;
            } else {
              result = DEFAULT_LOB;
            }
          }
          break;
        // Loads from session storage (i.e. customization widget)
        case checkIfExists(sessionStorageBusiness):
          result = value;
          break;
        // Loads from local storage (i.e. customization widget)
        case checkIfExists(localStorageBusiness):
          result = localStorageBusiness;
          break;
        // Default
        default:
          result = DEFAULT_LOB;
          break;
      }
      ;
      if (this.wasBusinessTypeOneTime) {
        spartaStoreUtility.removePersisted('wasBusinessTypeOneTime', 'sessionStorage');
        this.updateUrlQueryParams(sessionStorageBusiness, _that);
      } else {
        if (isOneTime) {
          spartaStoreUtility.removePersisted('businessTypeOneTime', 'sessionStorage');
          spartaStoreUtility.persist('wasBusinessTypeOneTime', businessTypeOneTime, 'sessionStorage');
        }
        // update query params with loaded audience
        if (result && result !== DEFAULT_LOB) {
          this.updateUrlQueryParams(result, _that);
        }
      }
      // delete one time override
      spartaStoreUtility.removePersisted('businessTypeOneTime', 'sessionStorage');
      return result || DEFAULT_LOB;
    } catch (e) {
      console.error("Error:", e); // TODO: Use proper logger
      return DEFAULT_LOB;
    }
  }

  /**
   * @desc check if user has opted out or targeting or alloy have been disabled
   * show default content if any are true
   * call adobe alloy service if false
   * Set timeout for default content to show if alloy fails or times out
   * @method getMarketingAssets
   * @param {string} container Name of ad (mbox) container to fetch content for
   * @returns {void}
   */
  getMarketingAssets() {
    if (this.customerType === "business") {
      if (this.optedOut || this.targetingDisabled || this.alloyDisabled) {
        this.optedOutRoute(this.businessContainer);
        this.optedOutRoute(this.aboveTheFoldContainers);
        this.optedOutRoute(this.belowTheFoldContainers);
      } else {
        // Check for stored cookie
        const businessSizeCookie = spartaStoreUtility.getPersisted("businessType", 'localStorage');
        const businessTypeOneTime = spartaStoreUtility.getPersisted('businessTypeOneTime', 'sessionStorage');
        const wasBusinessTypeOneTime = spartaStoreUtility.getPersisted('wasBusinessTypeOneTime', 'sessionStorage');
        spartaEventsUtility.sub('BUSINESS_HOMEPAGE_BUSINESS_SIZE_COMPLETE', ({
          data
        }) => {
          const properAudience = businessTypeOneTime ? QUERY_PARAM_TO_ALLOY_CONVERSION_BUSINESS_AUDIENCE[businessTypeOneTime] : data?.businessSize ? data.businessSize : businessSizeCookie;
          this.updateUrlQueryParams(this.convertAlloyBusinessSize(properAudience), wasBusinessTypeOneTime);
          this.getBusinessDesignation(data.businessSize, wasBusinessTypeOneTime);
        });
        // TODO: not used. This can be removed.
        // Update customPayload if needed for alloyEvent where we send the stored cookie from customization widget changes.
        const payload_businessContainer = {};
        if (businessSizeCookie) {
          payload_businessContainer.businessSize = businessSizeCookie;
        }
        // TODO: END
        // Use businessSize in payload if we have the cookie else just call alloy without additional payload
        if (this.businessContainer?.length && payload_businessContainer.businessSize) {
          this.alloyEvent(this.businessContainer, payload_businessContainer);
        } else {
          this.alloyEvent(this.businessContainer);
        }

        // Separating sign-on banner call for performance purposes and to prevent delays in rendering
        if (this.aboveTheFoldContainers?.length) this.alloyEvent(this.aboveTheFoldContainers);
        if (this.belowTheFoldContainers?.length) this.alloyEvent(this.belowTheFoldContainers);

        // Call Alloy when a new topic is opened
        spartaEventsUtility.sub('PICKER_TOPIC_TRANSMIT_EVENT', event_payload => {
          this.defaultContentRendered = false;
          isBusinessAdHoc = true;
          const {
            containers,
            payload
          } = event_payload.data;
          setTimeout(() => {
            this.alloyEvent(containers, payload, {
              isBusinessAdHoc
            });
          }, 0);
        }, true);
      }
    } else {
      if (this.optedOut || this.targetingDisabled || this.alloyDisabled) {
        this.optedOutRoute(this.signOnBannerAdContainer);
        this.optedOutRoute(this.mainAdContainers);
        this.optedOutRoute(this.navTabAdContainers);
      } else {
        // Separating sign-on banner call for performance purposes and to prevent delays in rendering
        if (this.signOnBannerAdContainer?.length) {
          this.alloyEvent(this.signOnBannerAdContainer);
        }
        if (this.mainAdContainers?.length) {
          this.alloyEvent(this.mainAdContainers);
        }
        // Only call L1 Nav ad containers when tab is opened
        spartaEventsUtility.sub('NAVTABS_READY', () => {
          const navElements = document.querySelectorAll('.main-nav-links li a');
          navElements.forEach(el => {
            el.addEventListener('click', () => {
              this.defaultContentRendered = false;
              const menuContainer = document.querySelector('.menu-content-container.active');
              if (menuContainer) {
                const section = menuContainer.querySelector('section.active');
                const adContainerId = [section.querySelector('.offer-container').id];
                this.alloyEvent(adContainerId);
              }
            });
          });
        }, true);
      }
    }
  }

  /**
   * @method alloyEvent
   * @param {string} containersArray array of targeted ad container
   * @param {object} customPayload Additional payload that needs to be sent to Alloy
   * @returns {void}
   */
  alloyEvent(containersArray, customPayload, opts = {}) {
    if (opts.isBusinessAdHoc) {
      isBusinessAdHoc = opts.isBusinessAdHoc;
    } else {
      isBusinessAdHoc = false;
    }
    let _containersArray = [...containersArray];
    if (!_containersArray?.length) _containersArray = [];
    // if default content has been rendered, return
    if (this.defaultContentRendered) {
      // eslint-disable-next-line no-console
      console.warn('Alloy is ready but default content has already rendered');
      return;
    }
    alloy('sendEvent', {
      xdm: {
        eventType: 'regionalmbox.request'
      },
      data: {
        __adobe: {
          target: {
            ...this.payload,
            ...customPayload,
            pageVersion: this.pageVersion
          }
        }
      },
      decisionScopes: _containersArray
    }).then(result => {
      if (result.propositions && result.propositions.length > 0) {
        const propositions = [];
        const {
          decisions
        } = result;
        // render ad containers based on results
        decisions.forEach(decision => {
          let proposition;
          const {
            scope
          } = decision;
          // ensure scope is among containers being requested
          if (containersArray.indexOf(scope) !== -1) {
            if (spaParams.siteParams.jsTimer && performance.mark !== undefined) {
              performance.mark(`${scope}-loadContent-start`);
            }
            // Added schema of default-content-item to handle issue where propositions were not passed on decisioning.propositionDisplay call.
            const filteredDecision = decision.items.filter(item => item.schema === 'https://ns.adobe.com/personalization/html-content-item' || item.schema === 'https://ns.adobe.com/personalization/default-content-item');
            if (filteredDecision.length > 0) {
              let content = filteredDecision[0]?.data?.content || {};
              this.dispatchTargetedContent(scope, content, '', {
                isBusinessAdHoc
              });
              proposition = {
                id: decision.id,
                scope,
                scopeDetails: decision.scopeDetails
              };
              propositions.push(proposition);
            } else {
              this.dispatchTargetedContent(scope, {});
            }
            if (this.customerType === "business") {
              // Because the module list hasn't been loaded yet we do not have the attribute loaded to the page. Should we add these again if they don't load in the homepage module?
              spartaEventsUtility.sub('SPARTA_BUS_HOMEPAGE.odm_modules_loaded', () => {
                if (this.completedScopes[scope]) return;
                this.completedScopes[scope] = true;
                const adContainers = document.querySelectorAll(`[data-ad-container='${scope}']`);
                if (this.completedContainers[scope]) return;
                adContainers.forEach(adContainer => {
                  // track ad container clicks
                  if (adContainer) {
                    // Only add this if this is for a targetted card tile
                    if (proposition && adContainer.id?.startsWith('business_hp_picker_card')) {
                      adContainer.dataset.proposition = JSON.stringify(proposition);
                      return;
                    }
                    if (!adContainer.id) {
                      // Check for a parent ID
                      if (adContainer.parentNode.id) {
                        adContainer = adContainer.parentNode;
                      }
                    }
                    if (scope === "business_hp_promo") {
                      adContainer = document.querySelector("#solution-finder-module");
                    }
                    const hasEv = adContainer.hasAttribute('ev-has-prop');
                    if (!hasEv) {
                      adContainer.addEventListener('click', () => {
                        setTimeout(() => {
                          if (this.completedContainers[scope].propCallInit) return;
                          this.completedContainers[scope].propCallInit = true;
                          // send click track event
                          alloy('sendEvent', {
                            xdm: {
                              // eventType denotes that a click was recorded
                              eventType: 'decisioning.propositionInteract',
                              _experience: {
                                decisioning: {
                                  propositions: [proposition]
                                }
                              }
                            }
                          });
                        }, 0);
                      });
                      // Add element so that we know the event was attached
                      adContainer.setAttribute('ev-has-prop', "true");
                      // Keep from retriggering completed containers.
                      this.completedContainers[scope] = {
                        complete: true,
                        propCallInit: false
                      };
                    }
                  }
                });
              }, true);
            } else {
              const adContainer = document.querySelector(`[data-ad-container='${scope}']`);
              // track ad container clicks
              if (adContainer) {
                adContainer.addEventListener('click', () => {
                  // send click track event
                  alloy('sendEvent', {
                    xdm: {
                      // eventType denotes that a click was recorded
                      eventType: 'decisioning.propositionInteract',
                      _experience: {
                        decisioning: {
                          propositions: [proposition]
                        }
                      }
                    }
                  });
                });
              }
            }
          }
        });
        // track displayed content
        alloy('sendEvent', {
          xdm: {
            // eventType denotes that targeted content was displayed
            eventType: 'decisioning.propositionDisplay',
            _experience: {
              decisioning: {
                propositions,
                propositionEventType: {
                  display: 1
                }
              }
            }
          }
        });
        this.alloyContentRendered = true;
        console.warn('Alloy content rendered');
      } else {
        console.error('Fell back to defaults for:', containersArray);
        this.dispatchDefault(containersArray);
      }
      bactm.impressions();
      return null;
    }).catch(err => {
      // Alloy call error, display default content
      console.error(err);
      const isCardDefault = this.dispatchDefault();
      // If we are fail to call Alloy and are updating picker cards then we will return so that the module handles the data.
      if (isCardDefault === 'SPARTA_CARD_DEFAULTS' && containersArray.includes("business_hp_picker_card1")) {
        spartaEventsUtility.pub('PICKER_TOPIC_TRANSMIT_EVENT_READY', {});
      }
    }).then(() => {
      if (isBusinessAdHoc) {
        isBusinessAdHoc = false;
      }
    });
  }

  /**
   * @description Render default content if:
   * Alloy content has not rendered
   * AND
   * Default content has not rendered
   * @method dispatchDefault
   * @returns {void}
   */
  dispatchDefault(containers) {
    if (containers?.length) {
      containers.forEach(container => {
        this.dispatchTargetedContent(container, {});
      });
    }
    if (!this.alloyContentRendered && !this.defaultContentRendered) {
      if (this.signOnBannerAdContainer?.length) {
        this.dispatchTargetedContent(this.signOnBannerAdContainer[0], {});
      }
      if (this.mainAdContainers?.length) {
        this.mainAdContainers.forEach(container => {
          this.dispatchTargetedContent(container, {});
        });
      }
      if (this.navTabAdContainers?.length) {
        this.navTabAdContainers.forEach(container => {
          this.dispatchTargetedContent(container, {});
        });
      }
      this.defaultContentRendered = true;
    }
  }

  /**
   * Parse JCR returned from targetting API and emit event with parsed content. Event name will be
   * 'target-[container]'. Parsed content will be included in event data.
   * This will be an empty object if
   * the targeting call failed or timed out or if the user has opted out of targeted content.
   *
   * @param {string} container Name of ad container that content is intended for.
   * @param {string} content Stringified JCR returned from targeting API.
   * @param {string} clickToken String click token
   * @returns {void}
   */
  dispatchTargetedContent(container, content = {}, clickToken = '', opts) {
    const viewAsBusinessQueryParameter = spartaStoreUtility.getPersisted('businessTypeOneTime', 'sessionStorage');
    // If on Business homepage
    if (this.customerType === "business") {
      // Call immediately for business audience size.
      if (container === 'business_hp_audience') {
        if (this.businessSizePublished) return;
        let contentObject = content;
        if (typeof contentObject === 'string') {
          contentObject = JSON.parse(content);
        }
        const sessionStorageBusiness = spartaStoreUtility.getPersisted('businessType', 'sessionStorage');
        const businessSize = viewAsBusinessQueryParameter ? viewAsBusinessQueryParameter : contentObject?.audience !== 'default' ? contentObject?.audience : sessionStorageBusiness || 'default';
        spartaEventsUtility.pub("BUSINESS_HOMEPAGE_BUSINESS_SIZE_COMPLETE", {
          complete: true,
          businessSize: businessSize
        });
        this.businessSizePublished = true;
        this.localBusinessSize = 'midSize';
        // this.localBusinessSize = contentObject?.audience || 'default'

        // Else wait for the odm_modules_loaded event
      } else {
        // Wait until SPARTA On Demand Modules are loaded before we continue.
        spartaEventsUtility.sub('SPARTA_BUS_HOMEPAGE.odm_modules_loaded', () => {
          // Handle Business Audience mBox
          if (container === 'business_hp_audience') {
            if (this.businessSizePublished) return;
            let contentObject = content;
            if (typeof contentObject === 'string') {
              contentObject = JSON.parse(content);
            }
          } else {
            if (isBusinessAdHoc) {
              this.handleBusinessTargetDispatch(container, content, clickToken, isBusinessAdHoc, opts);
              isBusinessAdHoc = false;
              // The following runs only for the Business Homepage /homepage/business after the Business Homepage Module fires the following event.
              this.handleBusinessTargetDispatch(container, content, clickToken);
            } else {
              if (viewAsBusinessQueryParameter) {
                this.handleBusinessTargetDispatch(container, {}, clickToken);
              } else {
                this.handleBusinessTargetDispatch(container, content, clickToken);
              }
            }
          }
        }, true);
      }
      // else we will do the original function logic.
    } else {
      if (typeof content === 'string') {
        const replacedContent = content.replace(this.cdnDarkPattern, this.cdn);
        try {
          const parsedContent = {
            ...JSON.parse(replacedContent),
            clickToken
          };
          if (this.responseIsValid(parsedContent.META)) {
            spartaEventsUtility.pub(`target-${container}`, parsedContent);
          } else {
            spartaEventsUtility.pub(`target-${container}`, {});
            remoteConsole.error(`Targeting Error: Meta Info mismatch for ${container}`);
          }
        } catch (e) {
          spartaEventsUtility.pub(`target-${container}`, {});
          const errorMsg = `Targeting Error: Invalid content returned for ${container}`;
          remoteConsole.info(errorMsg);
          console.error(errorMsg); // eslint-disable-line no-console
        }
      } else {
        spartaEventsUtility.pub(`target-${container}`, {});
      }
    }
  }
  handleBusinessTargetDispatch(container, content, clickToken) {
    const viewAsBusinessQueryParameter = spartaStoreUtility.getPersisted('businessTypeOneTime', 'sessionStorage');
    const wasBusinessQueryParameter = spartaStoreUtility.getPersisted('wasBusinessTypeOneTime', 'sessionStorage');
    const storedBusinessSize = viewAsBusinessQueryParameter ? viewAsBusinessQueryParameter : wasBusinessQueryParameter;
    if (storedBusinessSize) return;
    spartaEventsUtility.sub('SPARTA_BUS_HOMEPAGE.odm_modules_loaded', () => {
      let updatedContainer = container;
      if (updatedContainer === 'masthead') updatedContainer = 'business_hp_masthead';
      const targetAdElement = document.querySelector(`[data-ad-container="${updatedContainer}"]`);
      if (!targetAdElement) {
        return;
      }
      let defaultJCRAttribute = targetAdElement?.parentNode?.querySelector('.jcr_content .jcr_content-default')?.getAttribute('data-jcr');
      let defaultJCRData;
      if (defaultJCRAttribute) {
        defaultJCRData = defaultJCRAttribute;
      }
      // This is to handle a specific issue for Business Homepage where LOB is
      // adding "." so that there are only three cards on Product Picker
      if (content === ".") {
        content = {};
      } else {
        let contentTempObject = JSON.parse(JSON.stringify(content));
        if (!contentTempObject.hasOwnProperty('META') && defaultJCRData) {
          content = defaultJCRData;
        }
      }
      if (typeof content === 'string') {
        const replacedContent = content.replace(this.cdnDarkPattern, this.cdn);
        try {
          const parsedContent = {
            ...JSON.parse(replacedContent),
            clickToken
          };
          targetAdElement.setAttribute('data-ad-name', parsedContent.META.FRIENDLY_NAME);
          if (this.responseIsValid(parsedContent.META)) {
            // Show the response from Alloy
            if (isBusinessAdHoc) {
              spartaEventsUtility.pub('PICKER_TOPIC_TRANSMIT_EVENT_READY', parsedContent);
            } else {
              spartaEventsUtility.pub(`ALLOY_RESPONSE_TARGET-${container}`, parsedContent);
              spartaEventsUtility.pub(`target-${updatedContainer}`, parsedContent);
            }
          } else {
            // Show default information
            if (isBusinessAdHoc) {
              spartaEventsUtility.pub('PICKER_TOPIC_TRANSMIT_EVENT_READY', parsedContent);
            } else {
              spartaEventsUtility.pub(`target-${updatedContainer}`, {});
            }
            remoteConsole.error(`Targeting Error: Meta Info mismatch for ${updatedContainer}`);
          }
        } catch (e) {
          if (isBusinessAdHoc) {
            spartaEventsUtility.pub('PICKER_TOPIC_TRANSMIT_EVENT_READY', parsedContent);
          } else {
            spartaEventsUtility.pub(`target-${updatedContainer}`, {});
          }
          const errorMsg = `Targeting Error: Invalid content returned for ${updatedContainer}`;
          remoteConsole.info(errorMsg);
          console.error(errorMsg); // eslint-disable-line no-console
        }
      } else {
        if (isBusinessAdHoc) {
          spartaEventsUtility.pub('PICKER_TOPIC_TRANSMIT_EVENT_READY', {});
        } else {
          spartaEventsUtility.pub(`target-${updatedContainer}`, {});
        }
      }
    }, true);
  }

  /**
   * Checks all validations on targetted META info
   *
   * @param {Object} metaInfo - meta information to be validated
   * @returns {Boolean} true if all validations pass
   */
  responseIsValid(metaInfo) {
    return this.validateLanguage(metaInfo) && this.validateCustomerType(metaInfo);
  }

  /**
   * Validates that the customer_type matches the code set in meta
   *
   * @param {Object} meta - meta information set in JCR
   * @returns {boolean} true if customer_type matches what is specified in the page-config
   */
  validateCustomerType(meta = {}) {
    if (!meta.CUSTOMER_TYPE) {
      return true;
    }
    return this.customerPattern.test(meta.CUSTOMER_TYPE);
  }

  /**
   * Validates that the language pattern matches the code set in meta
   *
   * @param {Object} meta meta object
   * @returns {boolean} true if language codes match or not set, false otherwise.
   */
  validateLanguage(meta = {}) {
    if (!meta.LANGUAGE) {
      return true;
    }
    return this.langPattern.test(meta.LANGUAGE);
  }

  /**
   * Invokes bactm.log function after checking if bactm is not undefined.
   * @param {*} logObj log object
   * @returns {void}
   */
  bactmLog(logObj) {
    // eslint-disable-next-line no-undef
    if (typeof bactm !== 'undefined' && typeof bactm.log !== 'undefined') {
      // eslint-disable-next-line no-undef
      bactm.log(logObj);
    }
  }
}
const alloyBootstrapUtility = new AlloyBootstrapUtility();

export { alloyBootstrapUtility as default };
